import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { FlatRoomTypeSelect } from '../../../FlatRoomTypeSelect'
import { FLAT_FORM_FIELD_NAME_ROOM_TYPE } from '../../FlatForm.constants'

import { ROOM_TYPE_FIELD_API_PARAMS } from './RoomTypeField.constants'

function RoomTypeField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={FlatRoomTypeSelect}
      apiParams={ROOM_TYPE_FIELD_API_PARAMS}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Flat.RoomTypePlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: t('Flat.RoomTypeLabelKey'),
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={FLAT_FORM_FIELD_NAME_ROOM_TYPE}
    />
  )
}

export default RoomTypeField
